module.exports = __webpack_public_path__ + "img/kenya.b6edaf7b.png";